import { render, staticRenderFns } from "./AssignedRetailers.vue?vue&type=template&id=35d98100"
import script from "./AssignedRetailers.vue?vue&type=script&lang=js"
export * from "./AssignedRetailers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports